import { IonPage } from '@ionic/react'
import { useParams } from 'react-router'

import { TasksQueueView } from '@apps-common/apps/portal/pages/units/pages/program-tasks/pages/task-queue/components'
import { UnauthorizedCard } from '@apps-common/components/common'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'

export const UnitProgramTaskQueuePage = () => {
  const { taskId } = useParams<{ taskId: string }>()
  const id = taskId ? parseInt(taskId, 10) : undefined

  return (
    <IonPage>
      <Authorization
        roles={AUTH_CLAIMS.managementAdmin.roles}
        scopes={AUTH_CLAIMS.managementAdmin.scopes}
        notAuthorizedFallback={<UnauthorizedCard />}
      >
        <TasksQueueView taskGroupId={id} />
      </Authorization>
    </IonPage>
  )
}
